import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import { FaDownload } from 'react-icons/fa';
import base_url from '../config/Config';
import axios from "axios";
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import PageLoader from '../components/PageLoader';

const MasterSheet = () => {
    const [masterSheet, setMasterSheet] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');

    const getAllMasterSheet = () => {
        axios.get(`${base_url}/api1/export/listMerged`).then(
            (response) => {
                console.log(response.data);
                setMasterSheet(response.data);
            },
            (error) => {
                console.log(error);
            }
        ).finally(() => setPageLoading(false));
    };

    useEffect(() => {
        getAllMasterSheet();
    }, []);

    const handleSearch = (event) => {
        event.preventDefault();
        if (searchOption && searchInput) {
            let url = '';
            switch (searchOption) {
                case 'Fintech':
                    url = `${base_url}/api1/user/searchByPartnerName?partnerName=${searchInput}`;
                    break;
                case 'gst':
                    url = `${base_url}/api1/user/searchByGst?gst=${searchInput}`;
                    break;
                case 'phone':
                    url = `${base_url}/api1/user/searchByPhone?phone=${searchInput}`;
                    break;
                default:
                    break;
            }
            axios.get(url).then(
                (response) => {
                    console.log(response.data);
                    setMasterSheet(response.data);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    const handleExportFintech = async () => {
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api1/export/loanMasterSheet`, {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Master_Sheet_data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            console.log('Export Fintech successfully:', response.data);
            alert('Export Fintech successfully');
        } catch (error) {
            console.error('Error generating repayment:', error.response?.data || error.message);
            alert('Export Fintech not shown');
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <>
            <div className='overviewsaa'>
                <h4>All Master Sheet</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form onSubmit={handleSearch}>
                                            <div className='row'>
                                                <div className="col-md-3 col-3">
                                                    <div className=" required">
                                                        <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required="required">
                                                            <option value="" selected="selected">Search By</option>
                                                            <option value="Fintech">Fintech Partner</option>
                                                            <option value="gst">GST Number</option>
                                                            <option value="phone">Phone</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 col-6">
                                                    <div className=" required">
                                                        <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required/>
                                                    </div>
                                                </div>
                                                
                                                <div className="col-md-2 col-3">
                                                    <div className=" required">
                                                        <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                                    </div>
                                                </div>
                                                
                                                <div className='col-md-2 col-12 mt-2'>
                                                    <div className='export'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportFintech}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                    Export <FaDownload />
                                                                </>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='allcustomer table-responsive mb-5 mt-3'>
                                        { pageLoading ? <PageLoader text="Loading..." /> : masterSheet.length > 0  ? (
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>Loan_Id</th>
                                                        <th>Loan_Company</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Loan_Amount</th>
                                                        <th>Disbursed_Amount</th>
                                                        <th>UTR_NO</th>
                                                        <th>Disbursed_Date</th>
                                                        <th>Processing_Fees_GST</th>
                                                        <th>Processing_GST</th>
                                                        <th>Loan_Type</th>
                                                        <th>Repayment_Date</th>
                                                        <th>Repayment_Actual_Date</th>
                                                    </tr>
                                                    {masterSheet.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.loanId}</td>
                                                            <td>{data.loanCompany}</td>
                                                            <td>{data.customerName}</td>
                                                            <td>{data.loanAmount}</td>
                                                            <td>{data.principalAmount}</td>
                                                            <td>{data.utrNo}</td>
                                                            <td>{new Date(data.disbursedDate).toLocaleDateString()}</td>
                                                            <td>{data.processingFeesExcludingGST}</td>
                                                            <td>{data.gstOnPF}</td>
                                                            <td>{data.productType}</td>
                                                            <td>{new Date(data.dueDateOfRepayment).toLocaleDateString()}</td>
                                                            <td>{data.actualDateOfRepayment}</td>   
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            "No Master Data"
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MasterSheet;
